export const GET_TASK = state => {};

export const CREATED_DRAFT_TASK = state => {};

export const DELETED_TASK = state => {};

export const UPDATED_DRAFT_TASK = state => {};

export const PUBLISHED_LIVE_TASK = state => {};
